"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Broadcast/Modals/QueueMessages/Form.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);
var _moment = require('moment'); var _moment2 = _interopRequireDefault(_moment);


var _broadcastCampaign = require('shared/validation/broadcastCampaign');



var _Form = require('web/components/Form');
var _format = require('web/screens/Broadcast/format');
var _pace = require('web/screens/Broadcast/pace');
var _ScheduleTimeZone = require('web/components/ScheduleTimeZone'); var _ScheduleTimeZone2 = _interopRequireDefault(_ScheduleTimeZone);
var _timeZones = require('shared/services/timeZones');
var _PaceField = require('./PaceField'); var _PaceField2 = _interopRequireDefault(_PaceField);
var _SplitSendButton = require('./SplitSendButton'); var _SplitSendButton2 = _interopRequireDefault(_SplitSendButton);
var _GateSummary = require('./GateSummary');
var _schedule = require('./schedule');



























// The time list opens on 9 AM until a time is chosen.
const DEFAULT_CLOCK = _moment2.default.call(void 0, _schedule.clockTime.call(void 0, 9, 0))

const isValueValid = (v, max) => {
  if (isNaN(+v)) return false
  const numberValue = parseInt(v.toString())
  return numberValue > 0 && numberValue <= max
}

const QueueMessagesForm = ({
  isResume = false, gate, messageDelay, notScheduledCount, maxBatchSize = null,
  onClose, onStartCampaign, onSavePace, onSavingChange, timeZone: givenZone, onTimeZoneChange,
}) => {
  const [ownZone, setOwnZone] = _react.useState.call(void 0, _timeZones.deviceTimeZone)
  const timeZone = _nullishCoalesce(givenZone, () => ( ownZone))
  const changeZone = _nullishCoalesce(onTimeZoneChange, () => ( setOwnZone))
  const isCapped = maxBatchSize !== null && notScheduledCount > maxBatchSize
  const maxCount = isCapped ? maxBatchSize : notScheduledCount
  const [value, setValue] = _react.useState(maxCount)
  const isValid = isValueValid(value, maxCount)
  const count = isValid ? parseInt(value.toString()) : 0
  // Rev 28 R2: the pace, changed here only for this send until it's saved
  // with it; closing the dialog discards it.
  const savedPace = _nullishCoalesce(messageDelay, () => ( _broadcastCampaign.DEFAULT_MESSAGE_DELAY_MS))
  const [pace, setPace] = _react.useState.call(void 0, savedPace)
  // Which button's press is saving the pace (and whose save failed): its
  // label and its error show where it was pressed.
  const [savingFrom, setSavingFrom] = _react.useState(null)
  const [saveError, setSaveError] = _react.useState(null)
  const isSaving = !!savingFrom
  // Review R800-43: a save that settles after this form is gone launches
  // nothing (the dialog also can't be closed while it's out).
  const isMounted = _react.useRef.call(void 0, true)
  _react.useEffect.call(void 0, () => () => { isMounted.current = false }, [])
  _react.useEffect.call(void 0, () => { _optionalChain([onSavingChange, 'optionalCall', _ => _(isSaving)]) }, [isSaving, onSavingChange])
  // Rev 27 P4: a date and a quarter-hour time. Send dialog v2 (D-82): they
  // live in the Schedule for later popover and are kept while the dialog is
  // open; only its Schedule uses them, and Send now always sends now.
  const [isScheduleOpen, setIsScheduleOpen] = _react.useState.call(void 0, false)
  const [date, setDate] = _react.useState.call(void 0, '')
  const [time, setTime] = _react.useState(null)
  const [isTimeOpen, setIsTimeOpen] = _react.useState.call(void 0, false)
  const isScheduling = !!date || !!time
  // The past-time check runs on each edit, every 30 s while open, and on press.
  const [now, setNow] = _react.useState.call(void 0, () => Date.now())
  _react.useEffect.call(void 0, 
    () => {
      if (!isScheduling) return
      const id = setInterval(() => setNow(Date.now()), 30000)
      return () => clearInterval(id)
    },
    [isScheduling],
  )
  // Today on the zone's calendar, as a local midnight for the date picker.
  const todayWall = _timeZones.wallClock.call(void 0, new Date(now), timeZone)
  const today = new Date(todayWall.year, todayWall.month - 1, todayWall.day).toDateString()
  const disabledDays = _react.useMemo.call(void 0, () => ({ before: new Date(today) }), [today])
  const years = _react.useMemo.call(void 0, () => { const y = new Date(today).getFullYear(); return [y, y + 1] }, [today])
  const when = date && time ? _schedule.sendAt.call(void 0, date, time.hour, time.minute, timeZone) : null
  // Review R800-35: a time the clocks skip on the chosen day isn't sent as
  // the hour after; the form says so.
  const isSkipped = !!date && !!time && !when
  const isPast = !!when && _schedule.hasPassed.call(void 0, when, now)
  const scheduledAt = when && !isPast ? when.toISOString() : null
  // The zone for the chosen day, so a date after a DST change shows its own.
  const zoneAt = _nullishCoalesce(_nullishCoalesce(when, () => ( (date ? _schedule.sendAt.call(void 0, date, 12, 0, timeZone) : null))), () => ( new Date(now)))
  const zone = _format.formatZone.call(void 0, zoneAt, timeZone)

  const editDate = (v) => {
    setDate(v)
    setNow(Date.now())
  }
  const editTime = (m) => {
    setTime(m && { hour: m.hour(), minute: m.minute() })
    setNow(Date.now())
  }
  const sendLabel = savingFrom === 'now' ? 'Saving the pace…' : isResume ? 'Resume now' : 'Send now'
  const scheduleLabel = savingFrom === 'schedule' ? 'Saving the pace…' : 'Schedule'
  const duration = _pace.sendDuration.call(void 0, count, pace)
  const scheduleDesc = scheduledAt && count
    ? `${count === 1 ? 'The message starts' : `All ${_format.formatCount.call(void 0, count)} start`} at this time, at the pace you picked. ${duration.charAt(0).toUpperCase()}${duration.slice(1)}.`
    : 'Pick when the first message goes out.'

  const handleChange =
    e => setValue(e.target.value)

  // Review R800-19: a scheduled time is checked again as it's sent; one that
  // passed while the popover sat open is refused here, and it says so.
  const handleStart = (from) => {
    const isScheduled = from === 'schedule'
    if (isScheduled && (!when || _schedule.hasPassed.call(void 0, when, Date.now()))) {
      setNow(Date.now())
      return
    }
    const at = isScheduled ? scheduledAt : null
    const start = () => {
      onStartCampaign(count, at)
      onClose()
    }
    if (pace === savedPace) return start()
    setSavingFrom(from)
    setSaveError(null)
    onSavePace(pace)
      .then(() => {
        if (!isMounted.current) return
        // Review R800-44: the time is checked again once the pace is saved;
        // one that passed meanwhile is refused, and the saved pace stays.
        if (isScheduled && (!when || _schedule.hasPassed.call(void 0, when, Date.now()))) {
          setSavingFrom(null)
          setNow(Date.now())
          return
        }
        start()
      })
      .catch((e) => {
        log.error(e )
        if (!isMounted.current) return
        setSavingFrom(null)
        setSaveError(from)
      })
  }

  return (
    _react2.default.createElement(_react2.default.Fragment, null
      ,  gate && _react2.default.createElement(_GateSummary.SkippedNote, { gate: gate, __self: this, __source: {fileName: _jsxFileName, lineNumber: 169}} ) 
      ,  gate && _react2.default.createElement(_GateSummary.GateLead, { gate: gate, __self: this, __source: {fileName: _jsxFileName, lineNumber: 170}} ) 
      , _react2.default.createElement('div', { className: "campaign-controls--batch--form", __self: this, __source: {fileName: _jsxFileName, lineNumber: 171}}
        , _react2.default.createElement(_Form.InputSectionWrapper, {
          className: "campaign-controls--batch--size--wrapper",
          title: "Number of messages to send"    , __self: this, __source: {fileName: _jsxFileName, lineNumber: 172}}

          , _react2.default.createElement('div', { className: "campaign-controls--batch--size", __self: this, __source: {fileName: _jsxFileName, lineNumber: 176}}
            , _react2.default.createElement(_Form.RangeInput, {
              min: 1,
              max: maxCount,
              value: value,
              onChange: setValue,
              className: "campaign-controls--batch--size-range", __self: this, __source: {fileName: _jsxFileName, lineNumber: 177}}
            )
            , _react2.default.createElement(_Form.TextInput, {
              value: value,
              onChange: handleChange,
              hasError: !isValid,
              className: "campaign-controls--batch--size-input", __self: this, __source: {fileName: _jsxFileName, lineNumber: 184}}
            )
          )
        )
        , _react2.default.createElement(_PaceField2.default, {
          ms: pace,
          onChange: setPace,
          count: count,
          rest: count ? notScheduledCount - count : 0, __self: this, __source: {fileName: _jsxFileName, lineNumber: 192}}
        )
        , isCapped && (
          _react2.default.createElement('p', { className: "campaign-controls--batch--hint", __self: this, __source: {fileName: _jsxFileName, lineNumber: 199}}, "Up to "
              , maxBatchSize.toLocaleString('en-US'), " of the"  , ' '
            , notScheduledCount.toLocaleString('en-US'), " unscheduled messages can be sent in this batch. Start again afterwards to send the rest."

          )
        )
      )
      /* No Cancel: × closes the dialog (M4). */
      , _react2.default.createElement('div', { className: "blm-modal--buttons-wrapper broadcast-send--foot" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 207}}
        , _react2.default.createElement(_SplitSendButton2.default, {
          label: sendLabel,
          disabled: !isValid || isSaving,
          onSend: () => handleStart('now'),
          isOpen: isScheduleOpen,
          onOpenChange: setIsScheduleOpen,
          scheduleLabel: scheduleLabel,
          scheduleDisabled: !isValid || !scheduledAt || isSaving,
          onSchedule: () => handleStart('schedule'),
          isBusy: savingFrom === 'schedule', __self: this, __source: {fileName: _jsxFileName, lineNumber: 208}}

          , _react2.default.createElement('p', { className: "broadcast-popover--desc", __self: this, __source: {fileName: _jsxFileName, lineNumber: 219}},  scheduleDesc )
          , _react2.default.createElement('div', { className: "broadcast-send--when-row", __self: this, __source: {fileName: _jsxFileName, lineNumber: 220}}
            , _react2.default.createElement(_Form.DateInput, {
              ariaLabel: "Date",
              placeholder: "Date",
              value: date,
              onChange: editDate,
              disabledDays: disabledDays,
              years: years,
              hasError: isPast || isSkipped,
              className: "broadcast-send--date",
              popupClassName: "broadcast-send--date-popup", __self: this, __source: {fileName: _jsxFileName, lineNumber: 221}}
            )
            /* Escape in either popup closes only the popup (Popover keeps
                its keyup from the dialog; review R800-40), and the Schedule
                popover stays open under it. */
            , _react2.default.createElement(_Form.TimeInput, {
              ariaLabel: "Time",
              placeholder: "Time",
              isOpen: isTimeOpen,
              onOpen: () => setIsTimeOpen(true),
              onClose: () => setIsTimeOpen(false),
              value: time ? _moment2.default.call(void 0, _schedule.clockTime.call(void 0, time.hour, time.minute)) : undefined,
              defaultValue: DEFAULT_CLOCK,
              onChange: editTime,
              hasError: isPast || isSkipped,
              className: "broadcast-send--time",
              popupClassName: "broadcast-send--time-popup", __self: this, __source: {fileName: _jsxFileName, lineNumber: 235}}
            )
            , _react2.default.createElement('span', { className: "broadcast-send--zone", __self: this, __source: {fileName: _jsxFileName, lineNumber: 248}},  zone )
          )
          ,  isPast && (
            _react2.default.createElement('p', { role: "alert", className: "blm-input-section--error broadcast-send--when-error" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 251}}, "That time has passed. Pick a later time."

            )
          )
          ,  isSkipped && time && (
            _react2.default.createElement('p', { role: "alert", className: "blm-input-section--error broadcast-send--when-error" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 256}}
              ,  _moment2.default.call(void 0, _schedule.clockTime.call(void 0, time.hour, time.minute)).format('h:mm A') , " doesn't happen on "
               ,  _moment2.default.call(void 0, date, _moment2.default.HTML5_FMT.DATE).format('ddd, MMM D') , ": clocks go forward an hour. Pick another time."

            )
          )
          , _react2.default.createElement('div', { className: "broadcast-send--zone-line", __self: this, __source: {fileName: _jsxFileName, lineNumber: 262}}
            , _react2.default.createElement(_ScheduleTimeZone2.default, { timeZone: timeZone, onChange: changeZone, at: zoneAt, __self: this, __source: {fileName: _jsxFileName, lineNumber: 263}} )
          )
          ,  saveError === 'schedule' && (
            _react2.default.createElement('p', { role: "alert", className: "blm-input-section--error broadcast-send--when-error" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 266}}, "Couldn't save the send pace. Nothing was sent."

            )
          )
        )
      )
      ,  saveError === 'now' && (
        _react2.default.createElement('p', { role: "alert", className: "blm-input-section--error broadcast-send--save-error" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 273}}, "Couldn't save the send pace. Nothing was sent."

        )
      )
    )
  )
}

exports. default = QueueMessagesForm
